import type { BillingInfo } from '@fff-web/sdk-types';
import env from '../../utils/env';
import request from './request';

export const getBillingInfo = async (): Promise<BillingInfo> => {
  const endpoint = `${env.user}/users/self/billing/v2`;
  return request(endpoint);
};

export const updateBillingInfo = async (tokenId: string) => {
  const body = { token_id: tokenId };
  const data = JSON.stringify(body);
  const endpoint = `${env.revenueApi}/accounts/self/billing-info`;
  return request(endpoint, 'PUT', { 'Content-Type': 'application/json' }, data);
};

export const invalidateUserBillingInfo = () => {
  const endpoint = `${env.universalNavigationApi}/menu/cache/user-billing-info`;
  request(endpoint, 'DELETE', { 'Content-Type': 'application/json' });
};
